(function () {
    // 注册组件
    SR.component.extend('customerService', customerService);

    function customerService() {
        if (!SR.data.customerServiceAPI) {
            return;
        }
        var API = SR.data.customerServiceAPI;
        var CSTip = SR.data.customerServiceTip;
        var appcid = SR.util.urlParam('appcid');
        var sn = SR.permissions.sn;
        var uid = SR.data.guid || SR.data.jsid;
        var errorCount = 0;
        var pollingTimer;
        var pollingTime = 2000;
        var pollingXHR;
        var pollingType;
        var historyMsgCache;
        var maxRetryCount = 5;              // 重连次数
        var isUploading = false;
        var currentConnectState = 200;      // 维护客户端关键状态，默认初始值 200
        var hasConnected = false;           // 是否成功连接客服
        var hasQueue = false;               // 是否进入排队
        // var connectInitTimer;
        var connectWaitingTimer;
        // var CONNECTING_INIT_TIMEOUT = 10000;            // 连接初始化超时时长
        var CONNECTING_WAITING_TIMEOUT = 30000;         // 连接成功后等待座席时长
        var CONNECT_TIP = CSTip.CONNECT_TIP;
        var DISCONNECT_TIP = CSTip.DISCONNECT_TIP;
        var CONNECT_TIMEOUT_TIP = CSTip.CONNECT_TIMEOUT_TIP;
        var DISCONNECT_ERROR_TIP = CSTip.DISCONNECT_ERROR_TIP;
        var CONNECT_ERROR_TIP = CSTip.CONNECT_ERROR_TIP;
        var STAFF_TITLE = CSTip.STAFF_TITLE;
        var CONNECTING_TIP = CSTip.CONNECTING_TIP;
        var NON_WORKING_TIME_TIP = CSTip.NON_WORKING_TIME_TIP;
        var HISTORY_TIP = CSTip.HISTORY_TIP;
        // 
        var isImmersive = SR.state.isImmersive;
        var showAnimate = SR.state.showAnimate;
        var $body = SR.dom.$body;
        var $wrapper = SR.dom.$wrapper;
        var $scrollWrap = SR.dom.$scrollWrap;
        var loadingTag = SR.data.loadingTag;
        var xhrTimeout = 10000; //SR.data.xhrTimeout;
        var contentWidth = SR.data.deviceInfo.width;
        var scrollAnimateDuration = SR.data.scrollAnimateDuration;
        if (isImmersive) {
            contentWidth -= 30;
        } else {
            contentWidth -= 80;
            contentWidth = contentWidth > (340 - 20) ? (340 - 20) : contentWidth;
        }
        // 切换按钮
        var $askModeToggle = $('<div class="ask-mode-toggle J_CSChangeMode robot">robot</div>');
        SR.dom.$body.append($askModeToggle);
        
        SR.dom.$body.on('click', '.J_CSChangeMode', function(e) {
            e.preventDefault();
            var $me = $(this);
            var nextMode = $me.attr('data-tomode');                     // 人工客服按钮
            if (!nextMode) {
                nextMode = $me.hasClass('robot') ? 'staff' : 'robot';   // 开关
            }
            changeMode(nextMode, 'initiative');
        });

        SR.dom.$body.on('click', '.J_CSConnect', function(e) {
            e.preventDefault();
            connect();
        });

        SR.dom.$body.on('click', '.J_fadeOut', function(e) {
            e.preventDefault();
            var $me = $(this);
            $me.fadeOut();
        });

        SR.dom.$body.on('click', '.J_CSGrade', function(e) {
            e.preventDefault();
            var $me = $(this);
            if ($me.hasClass('hasTriggered')) {
                return;
            }
            renderGradeCard('force');
            $me.addClass('hasTriggered');
        });

        SR.dom.$body.on('click', '.J_exitQueue', function(e) {
            e.preventDefault();
            if (currentConnectState === 203) {
                // 排队状态下才能断开
                changeMode('robot', 'initiative');
            }
        });

        // 评分选择
        SR.dom.$body.on('click', '.J_selectGrade', function(e) {
            e.preventDefault();
            var $me = $(this);
            var $item = $(e.target);
            if (!$item.hasClass('grade-item')) {
                $item = $item.parents('.grade-item');
            }
            var $grade = $item.parents('.grade');
            if ($grade.hasClass('graded')) {
                return;
            }
            if ($item.hasClass('grade-item')) {
                $me.find('.grade-item').removeClass('selected');
                $item.addClass('selected');
                $grade.addClass('has-selected');
            }
        });
        // 提交评分
        SR.dom.$body.on('click', '.J_submitGrade', function(e) {
            var $btn = $(this);
            var $grade = $btn.parents('.grade');
            var val = $grade.find('.selected').attr('data-grade');
            if ($grade.hasClass('grading') || $grade.hasClass('graded')) {
                return;
            }
            if (!val) {
                SR.component.toast.show({msg: '请选择一个评分'});
                return;
            }
            $grade.addClass('grading');
            $.ajax({
                method: 'POST',
                timeout: xhrTimeout,
                url: API + '/grade',
                data: {
                    appcid: appcid,
                    sn: sn,
                    uid: uid,
                    grade: val,
                }
            }).done(function(data) {
                if (data.ret === 0) {
                    $grade.addClass('graded');
                    SR.component.toast.show({msg: '评分成功'});
                } else {
                    SR.component.toast.show({msg: '评分失败，请重试'});
                }
            }).fail(function(err) {
                SR.component.toast.show({msg: '评分失败，请重试'});
            }).always(function() {
                $grade.removeClass('grading');
            });
        });
        // 不再显示评分
        SR.dom.$body.on('click', '.J_hideGrade', function(e) {
            var $me = $(this);
            var isHide = $me.hasClass('checked');
            if (isHide) {
                $me.removeClass('checked');
                SR.util.updateStorage('hideGrade', 0);
            } else {
                $me.addClass('checked');
                SR.util.updateStorage('hideGrade', 1);
            }
        });

        // 主动发送
        SR.App.on('beforeAsk', function(e, options) {
            if (SR.state.askMode === 'staff' && currentConnectState === 200) {
                options.continue = false;
            }
        });
        SR.App.on('askFire:staff', function(e, options) {
            if ($body.hasClass(loadingTag)) {
                return;
            }
            $body.addClass(loadingTag);
            sendMsg(options.question);
        });
        // 连接事件
        SR.App.on('cs_connect', function() {
            var nextMode = 'staff';
            // 更新dom状态
            $askModeToggle.removeClass('robot staff').addClass(nextMode).text(nextMode);
            reportLastQuestions();
            SR.dom.$title.text(STAFF_TITLE);
            // 设置 SDK
            if (SR.state.isNative && !SR.state.isDebug) {
                upNativeComm.exec('smartRobot.setRobotStatus', {
                    status: '2',
                });
                upNativeComm.exec('WebView.setTitle', {
                    title: STAFF_TITLE,
                });
            }
        });
        // 断开事件
        SR.App.on('cs_disconnect', function() {
            var nextMode = 'robot';
            // 更新Dom状态
            $askModeToggle.removeClass('robot staff').addClass(nextMode).text(nextMode);
            $('.customer-service-queue').removeClass('onQueue');
            SR.dom.$title.text(SR.permissions.title);
            // 设置 SDK
            if (SR.state.isNative && !SR.state.isDebug) {
                upNativeComm.exec('smartRobot.setRobotStatus', {
                    status: '1',
                });
                upNativeComm.exec('WebView.setTitle', {
                    title: SR.permissions.title,
                });
            }
        });
        // 收到消息
        SR.App.on('cs_receive', function() {
            if (hasQueue) {
                renderQueueMsg(0);
            }
        });

        // ---------------------------------
        // function
        // ---------------------------------

        // 变更状态
        function changeMode(nextMode, disconnectType) {
            if (SR.state.askMode === nextMode) {
                return;
            }
            if (nextMode === 'staff') {
                connect();
            } else if (nextMode === 'robot') {
                disconnect(disconnectType);
            }
        }

        // 连接
        function connect() {
            if (SR.state.CSConnecting) {
                 return;
            }
            SR.state.CSConnecting = true;
            var nextMode = 'staff';
            SR.state.askMode = nextMode;
            // 广播事件
            var triggerEvent = 'cs_connect';
            SR.App.trigger(triggerEvent);
            SR.state.isDebug && console.info('fire:' + triggerEvent);
            // 发起断开请求
            // $.ajax({
            //     method: 'POST',
            //     timeout: xhrTimeout,
            //     url: API + '/polling',
            //     data: {
            //         pollingType: 'disconnect',
            //         appcid: appcid,
            //         sn: sn,
            //         uid: uid
            //     }
            // }).done(function(data) {
            //     // 无需处理回调
            // });
            // 开始轮询
            polling();
            // clearTimeout(connectInitTimer);
            // connectInitTimer = setTimeout(function() {
            //     if (currentConnectState === 200) {
            //         disconnect('error');
            //     }
            // }, CONNECTING_INIT_TIMEOUT);
            // 判断 208 状态是否超时
            clearTimeout(connectWaitingTimer);
            connectWaitingTimer = setTimeout(function() {
                disconnect('timeout');
            }, CONNECTING_WAITING_TIMEOUT);
        }

        // 发送消息
        function sendMsg(content, type, successCb, errorCb) {
            if (!appcid || !appcid.length || !sn || !sn.length || !content || !content.length) {
                return;
            }
            var msgType = type || 'text';
            $.ajax({
                method: 'POST',
                timeout: xhrTimeout,
                url: API + '/send',
                data: {
                    appcid: appcid,
                    sn: sn,
                    uid: uid,
                    msgType: msgType,
                    content: content,
                }
            }).done(function(data) {
                if (data.ret === 0) {
                    successCb && successCb(data);
                } else {
                    errorCb && errorCb(data);
                }
            }).fail(function(err) {
                errorCb && errorCb(err);
            }).always(function() {
                $body.removeClass(loadingTag);
            });
        }

        // 断开连接
        function disconnect(type) {
            SR.state.CSConnecting = false;
            var nextMode = 'robot';
            var $connectStatus = $('.customer-service-connect-status').last();
            // 广播事件
            var triggerEvent = 'cs_disconnect';
            SR.App.trigger(triggerEvent);
            SR.state.isDebug && console.info('fire:' + triggerEvent);
            if (pollingXHR) {
                pollingXHR.abort();
            }
            SR.state.askMode = nextMode;
            clearInterval(pollingTimer);
            // clearTimeout(connectInitTimer);
            clearTimeout(connectWaitingTimer);
            $connectStatus.addClass('done');
            switch(type) {
                case 'error':
                    // 因错误而断开连接
                    updateConnectStatus({
                        type: 'disconnect done error',
                        msg: DISCONNECT_ERROR_TIP
                    });
                    break;
                case 'timeout':
                    // 因等待座席超时断开连接
                    updateConnectStatus({
                        type: 'disconnect done timeout',
                        msg: CONNECT_TIMEOUT_TIP
                    });
                    break;
                case 'silent':
                    // 静默断开
                    break;
                case 'nonWorkingTime':
                    // 非工作时间
                    renderStaffMsg({
                        msgId: 'non-working-time ' + 'msgId-' + Date.now(),
                        msg: NON_WORKING_TIME_TIP
                    });
                    break;
                default:
                    updateConnectStatus({
                        type: 'disconnect done',
                        msg: DISCONNECT_TIP
                    });
                    break;
            }
            if (hasConnected && type === 'initiative') {
                // 主动断开
                renderGradeCard();
            }
            // 发起断开请求
            $.ajax({
                method: 'POST',
                timeout: xhrTimeout,
                url: API + '/polling',
                data: {
                    pollingType: 'disconnect',
                    appcid: appcid,
                    sn: sn,
                    uid: uid
                }
            }).done(function(data) {
                // 断开后切换状态，避免当前页面再次连接且未成功时，断开连接也会出现评分
                hasConnected = false;
                hasQueue = false;
                // 发起退出排队请求
                $.ajax({
                    method: 'POST',
                    timeout: xhrTimeout,
                    url: API + '/polling',
                    data: {
                        pollingType: 'exitQueue',
                        appcid: appcid,
                        sn: sn,
                        uid: uid
                    }
                }).done(function(data) {

                });
            });
        }

        // 更新连接状态
        function updateConnectStatus(options) {
            var $connectStatus = $('.customer-service-connect-status').last();
            var statuStyle = options.type || '';
            var hasStatusDom = $connectStatus.length;
            var cancelBtn = '<span class="J_fadeOut J_CSChangeMode cs-btn cancel-btn" data-tomode="robot">取消</span>';
            var html = cancelBtn;
            var outsideHtml = '';
            if ($connectStatus.hasClass('done')) {
                // 页面中会有多个 $connectStatus，当含有 done 类名时表示上一个已结束的状态
                // 这是就跳过这个 dom，创建一个新的 $connectStatus
                hasStatusDom = false;
            }
            if (statuStyle.indexOf('connecting') !== -1) {
                outsideHtml = '<span class="connecting-tip">'+ CONNECTING_TIP +'</span>';
            }
            if (statuStyle.indexOf('disconnect') !== -1) {
                // html = '<span class="J_CSGrade cs-btn grade-btn">评分</span>';
                html = '';
            }
            if (statuStyle.indexOf('error') !== -1) {
                html = '<span class="J_fadeOut J_CSConnect cs-btn grade-btn">重试</span>';
            }
            if (!hasStatusDom) {
                var templateHTML = template('customer_service', {
                    id: 'answerId-' + Date.now(),
                    className: 'customer-service-connect-status ' + statuStyle,
                    answer: options.msg,
                    html: html,
                    outsideHtml: outsideHtml,
                });
                $connectStatus = $(templateHTML);
                $wrapper.append($connectStatus);
                setScrollPos();
            } else {
                // 目前状态：error, success, disconnect, done
                // 需要清理的状态是：error, success
                $connectStatus.removeClass('error success').find('.answer').text(options.msg);
                if (statuStyle.length) {
                    $connectStatus.addClass(statuStyle);
                }
            }
        }

        // 渲染客服对话
        function renderStaffMsg(options) {
            var msgId = 'msgId-' + options.msgId;
            var $sameMsg = $('#' + msgId);     // 正在输入阶段的 msgId 固定为 writing
            var $writing = $('.writing');
            var statuStyle = options.type || '';
            var outsideHtml = '';
            var msgType = 'text';
            // var msgType = options.msgType === 1 ? 'image' : 'text';
            switch(options.msgType) {
                case 0:
                    msgType = 'text';
                    break;
                case 1:
                    msgType = 'image';
                    break;
                case 2:
                    // msgType = 'voice';   // 回复信息暂无语音类型
                    break;
                case 3:
                    msgType = 'history';
                    statuStyle = 'history';
                    outsideHtml = '<span class="outside-tip">'+ HISTORY_TIP +'</span>';
                    break;
            }
            if ($sameMsg.length) {
                return;
            }
            // if (msgType === 'text' && (!options.msg || options.msg.length === 0)) {
            //     // 避免空回复
            //     return;
            // }
            if ($writing.length) {
                var $msg = $writing.parents('.msg.staff');
                $msg.remove();
            }
            var templateHTML = template('customer_service', {
                id: msgId,
                msgType: msgType,
                className: statuStyle,
                answer: options.msg,
                outsideHtml: outsideHtml,
            });
            $wrapper.append(templateHTML);
            setScrollPos();
        }

        // 评分卡片
        function renderGradeCard(type) {
            // force 强制显示
            var templateHTML = '';
            if (SR.util.getStorage('hideGrade') === 1) {
                var $lastStatusDom = $('.disconnect.done').last();
                if ($lastStatusDom.find('.J_CSGrade').length === 0) {
                    $lastStatusDom.append('<span class="cs-btn J_fadeOut J_CSGrade">服务评价</span>');
                }
            }
            if (type === 'force' || SR.util.getStorage('hideGrade') !== 1) {
                templateHTML = template('customer_service_grade', {
                    id: 'grade',
                    className: 'grade',
                    hideGrade: SR.util.getStorage('hideGrade') === 1
                });
            }
            $wrapper.append(templateHTML);
            setScrollPos();
        }

        // 排队状态
        function renderQueueMsg(position) {
            if (position === undefined) {
                return;
            }
            var $customerServiceQueue = $('.customer-service-queue');
            if ($customerServiceQueue.hasClass('onQueue')) {
                $customerServiceQueue.find('.position').text(position);
            } else {
                var templateHTML = template('customer_service_queue', {
                    id: 'csQueue',
                    position: position,
                    avatar: SR.data.userInfo.userAvatar
                });
                $wrapper.append(templateHTML);
                setScrollPos();
            }
        }

        function reportLastQuestions() {
            var lastQuestions = [];
            var questionsArray = localStorage.getItem('allQuestions');
            questionsArray = !!questionsArray ? JSON.parse(questionsArray) : questionsArray;
            if (!questionsArray) {
                return;
            }
            $(questionsArray).each(function(index) {
                if (index > 2) {
                    return;
                }
                lastQuestions.push(this.q);
            });
            lastQuestions = lastQuestions.join(',');
            $.ajax({
                method: 'POST',
                timeout: xhrTimeout,
                url: API + '/report',
                data: {
                    appcid: appcid,
                    sn: sn,
                    uid: uid,
                    questions: lastQuestions,
                }
            }).done(function(data) {
                if (data.ret === 0) {
                }
            }).fail(function(err) {
            }).always(function() {
            });
        }
        // reportLastQuestions();

        // 轮询获取状态
        function polling() {
            if (!appcid || !appcid.length || !sn || !sn.length) {
                return;
            }
            pollingType = 'start';
            updateConnectStatus({
                type: 'connecting',
                msg: CONNECT_TIP
            });
            
            pollingTimer = setInterval(function () {
                pollingXHR = $.ajax({
                    method: 'POST',
                    timeout: xhrTimeout,
                    url: API + '/polling',
                    data: {
                        pollingType: pollingType,
                        appcid: appcid,
                        sn: sn,
                        uid: uid
                    }
                }).done(function(data) {
                    if (data.ret === 0) {
                        // clearTimeout(connectInitTimer);
                        if (data.status !== 208) {
                            clearTimeout(connectWaitingTimer);
                        }
                        switch(data.status) {
                            case 201:   // 会话创建成功
                            case 202:   // 分配座席成功
                                updateConnectStatus({
                                    msg: data.statusMsg
                                });
                                break;
                            case 203:    // 排队中
                                renderQueueMsg(data.position);
                                hasQueue = true;
                                break;
                            case 204:   // 进入会话过程
                                updateConnectStatus({
                                    type: 'success',
                                    msg: data.statusMsg
                                });
                                hasConnected = true;
                                break;
                            case 205:   // 客服输入中
                                renderStaffMsg({
                                    msgId: 'writing',
                                    type: 'writing',
                                    msg: data.statusMsg
                                });
                                break;
                            case 206:   // 客服回复
                                var triggerEvent = 'cs_receive';
                                var replyMsgArray = data.replyMsg;
                                SR.App.trigger(triggerEvent);
                                if (replyMsgArray.length) {
                                    if (historyMsgCache && historyMsgCache.length) {
                                        // 合并历史消息
                                        replyMsgArray = replyMsgArray.concat(historyMsgCache);
                                        historyMsgCache = undefined;
                                    }
                                    $(replyMsgArray).each(function() {
                                        var me = this;
                                        renderStaffMsg({
                                            msgId: me.msgId,
                                            msgType: me.msgType,
                                            msg: me.content
                                        });
                                    });
                                }
                                // 目前 208 直接进入 206
                                hasConnected = true;
                                break;
                            case 207:   // 客服主动断开
                                // renderStaffMsg({
                                //     msgId: 'disconnect',
                                //     msg: data.msg
                                // });
                                disconnect('initiative');
                                break;
                            case 208:   // 等待状态
                                
                                break;
                            case 260:
                                if (data.replyMsg.length) {
                                    historyMsgCache = data.replyMsg;
                                }
                                break;
                            case 401:   // 非工作时间 
                                disconnect('nonWorkingTime');
                                break;
                            case 403:   // 会话超时
                                disconnect('error');
                                break;
                            case 404:   // 会话关闭
                                disconnect();
                                break;
                        }
                        errorCount = 0;
                        currentConnectState = data.status;
                    } else {
                        automaticRetry();
                    }
                    pollingType = 'polling';
                }).fail(function() {
                    automaticRetry();
                }).always(function() {
                    $body.removeClass(loadingTag);
                });
            }, pollingTime);
        }

        function automaticRetry() {
            ++errorCount;
            if (errorCount === maxRetryCount) {
                errorCount = 0;
                updateConnectStatus({
                    type: 'error',
                    msg: CONNECT_ERROR_TIP
                });
                disconnect('error');
            }
        }

        function setScrollPos() {
            setTimeout(function() {
                var scrollTop = SR.dom.$historyWrapper.height() + $wrapper.height();
                $scrollWrap.animate(
                    {scrollTop: scrollTop},
                    (showAnimate ? 300 : scrollAnimateDuration)
                );
            }, 100);
        } 

        var uploadImg = function(imgBase64, type) {
            if (isUploading) {
                return false;
            }
            if (!imgBase64 || !imgBase64.length || !type) {
                renderUploadErr('图片格式不正确，请上传 png、jpeg、gif 格式的图片');
                return false;
            }
            var imgData = imgBase64;
            if (imgData.indexOf('base64') === -1) {
                imgData = 'data:image/'+ type +';base64,' + imgBase64;
            }
            imgData = encodeURIComponent(imgData);
            var imgDataLen = imgData.length;
            if (imgDataLen > 3 * 1000 * 1000) {
                renderUploadErr('图片太大，请上传小于 3M 的图片');
                return false;
            }
            isUploading = true;
            renderUploading();
            $.ajax({
                method: 'POST',
                timeout: xhrTimeout,
                url: API + '/upload',
                dataType: 'json',
                data: {
                    appcid: appcid,
                    sn: sn,
                    uid: uid,
                    fileData: imgData,
                }
            }).done(function(data) {
                if (data.ret === 0 && data.url) {
                    sendMsg(data.url, 'image', function() {
                        renderImg(data.url);
                    }, function(err) {
                        renderUploadErr('消息发送失败，请重试！');
                    });
                } else {
                    renderUploadErr('上传错误，请重试！');
                }
            }).fail(function(err) {
                renderUploadErr('上传错误，请重试！');
            }).always(function() {
                isUploading = false;
            });

            function renderUploading() {
                var templateHTML = template('ask_img', {
                    id: 'img_uploading',
                    type: 'uploading',
                    avatar: SR.data.userInfo.userAvatar
                });
                $wrapper.append(templateHTML);
                setScrollPos();
            }

            function renderImg(url) {
                $('#img_uploading').remove();
                var templateHTML = template('ask_img', {
                    id: 'img',
                    imgUrl: url,
                    avatar: SR.data.userInfo.userAvatar
                });
                $wrapper.append(templateHTML);
                setScrollPos();
            }

            function renderUploadErr(msg, err, imgData) {
                var errMsg = msg || '上传图片错误，请重试！';
                $('#img_uploading').attr('id', '#img_uploading_err').find('.content').empty().text(errMsg);
            }
        };
        window.uploadImg = uploadImg;

        window.setSRCommStates = function(type) {
            if (SR.permissions.appName === 'wukuang' || SR.permissions.appName === 'wukuangTHS') {
                window.ask('人工客服');
                return
            }
            if (type) {
                changeMode(type, 'initiative');
            }
        }
    }
})();